import { Route, Routes } from "react-router-dom";

import { Platform } from "@av/apps/common-apps/platform/components/Platform";
import { Tracking } from "@av/apps/common-apps/platform/components/tracking/Tracking";
import { NoAppAccessErrorPage } from "@av/apps/common-apps/platform/pages/NoAppAccessErrorPage";
import { useAdminSettingsNavigation } from "@av/apps/common-apps/platform/routes/useAdminSettingsNavigation";
import { useApps } from "@av/apps/common-apps/platform/services/apps/apps";
import { GenericErrorPage } from "@av/components/templates/layouts/errors/types/GenericErrorPage";
import { NotFoundPage } from "@av/components/templates/layouts/errors/types/NotFoundPage";
import { getAntdLocale } from "@av/config/i18n/antdLocales";
import { i18nInstance } from "@av/config/i18n/i18n-bundle";
import { RootLayout } from "@av/pages/layouts/RootLayout";

/**
 * Render apps which the current user has access to
 */
export function AppResolver() {
  const { data: apps, isLoading, error } = useApps();
  const adminSettingsControls = useAdminSettingsNavigation();
  const antdLocale = getAntdLocale(i18nInstance);

  if (isLoading) {
    return null;
  }

  if (!apps || error) {
    return (
      <GenericErrorPage
        onDismissError={() => {
          console.log({ apps, error });
        }}
      />
    );
  }

  if (apps.length === 0) {
    return <NoAppAccessErrorPage />;
  }

  const firstAppPath = apps[0].path;

  return (
    <>
      <Tracking />
      <Routes>
        <Route path="/" element={<RootLayout firstAppPath={firstAppPath} />}>
          {apps.map(({ path, apiUrl, component: Component }) => (
            <Route
              key={path}
              path={`${path}/*`}
              element={
                <Component
                  adminSettingsControls={adminSettingsControls}
                  apiUrl={apiUrl}
                  currentAntdLocale={antdLocale}
                />
              }
            />
          ))}
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Platform apps={apps} />
    </>
  );
}
